import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { ToastService } from './toast.service';
import { DocumentPayload, FileUploadResponse, QLEDocument } from 'src/app/models/document';
import { ToastType } from '../constants/toast-type';
import { FileService } from './file.service';
import { NextPanel } from '../models/next-panel';
import { ApiHeaderType } from '../constants/api-header-type';


@Injectable()
export class FileUploadService {

    constructor(
        private apiService: ApiService,
        private toastService: ToastService,
        private fileService: FileService,
    ) {
    }

    public submitCheckoutWaiveDocuments(payload: DocumentPayload): Observable<NextPanel> {
        const l_FormData: FormData = this.fileService.filesToFormData(payload.files);
        this.fileService.appendToFormData(l_FormData, 'MemberID', payload.memberID);
        this.fileService.appendToFormData(l_FormData, 'DependentID', payload.dependentID);

        return this.apiService.post('/checkout/waive-documents', l_FormData, ApiHeaderType.formData).pipe(
            map((response: NextPanel) => {
                this.toastUploadResponse(new FileUploadResponse());
                return response;
            }),
        );
    }

    public uploadDependentDocuments(payload: DocumentPayload): Observable<FileUploadResponse> {
        const l_FormData: FormData = this.fileService.filesToFormData(payload.files);
        this.fileService.appendToFormData(l_FormData, 'DependentID', payload.dependentID);

        return this.apiService.post('/mydependents/dependent-document', l_FormData, ApiHeaderType.formData).pipe(
            map((response: FileUploadResponse) => {
                this.toastUploadResponse(response);
                return response;
            }),
        );
    }

    public uploadLifeEventDocuments(payload: DocumentPayload): Observable<FileUploadResponse> {
        const l_FormData: FormData = this.fileService.filesToFormData(payload.files);
        this.fileService.appendToFormData(l_FormData, 'MemberID', payload.memberID);
        this.fileService.appendToFormData(l_FormData, 'DependentID', payload.dependentID);
        this.fileService.appendToFormData(l_FormData, 'QualifyingEventType', payload.qualifyingEventType);

        return this.apiService.post('/myprofile/member-document/qualifying-event', l_FormData, ApiHeaderType.formData).pipe(
            map((response: FileUploadResponse) => {
                this.toastUploadResponse(response);
                return response;
            }),
        );
    }

    public uploadQLEDocuments(payload: DocumentPayload): Observable<QLEDocument[]> {
        const l_FormData: FormData = this.fileService.filesToFormData(payload.files);
        this.fileService.appendToFormData(l_FormData, 'DependentID', payload.dependentID);
        this.fileService.appendToFormData(l_FormData, 'QLERequestID', payload.qleRequestID);

        return this.apiService.post('/myqle/qle-documents', l_FormData, ApiHeaderType.formData).pipe(
            map((response: QLEDocument[]) => {
                this.toastService.buildToastMessage(ToastType.success, "Document Uploaded", "Document Successfully added to Life Event Request");
                return response;
            }),
        );
    }

    public uploadCheckoutSignature(image: Blob): Observable<void> {
        const l_FormData: FormData = new FormData();
        l_FormData.append('File', image);

        return this.apiService.post('/checkout/finalize-signature', l_FormData, ApiHeaderType.formData).pipe(
            map((response: null) => {
                return response;
            }),
        );
    }

    private toastUploadResponse(response: FileUploadResponse): void {
        if (response.failedUploadCount > 0)
            this.toastService.buildToastMessage(ToastType.error, 'Upload Failed', 'Try uploading files again.');
        else
            this.toastService.buildToastMessage(ToastType.success, 'Success', 'All files uploaded!');
    }
}